import { Box, Button, Typography } from "@mui/material";
import { DialogShell } from "@/shared/components/ui";
import { TERMS_VERSION } from "@/shared/constants/legal";

const sections = [
  [
    "THE AGREEMENT",
    "By creating or using a Chessla account, you agree to these Terms and the Privacy Notice. You must be old enough to form a binding agreement where you live and are responsible for keeping your account secure.",
  ],
  [
    "THE SERVICE",
    "Chessla analyzes games and offers coaching tools. It is for personal chess improvement, not a promise of a result, rating, tournament outcome, or professional advice.",
  ],
  [
    "NIKOLA'S CLUB",
    "Club memberships renew through Stripe until cancelled. You can manage or cancel a membership from Chessla. Payments are not voluntarily refundable, except where applicable law requires otherwise.",
  ],
  [
    "YOUR GAMES AND PLATFORM IMPROVEMENT",
    "You keep ownership of the games and profile information you provide. You permit Chessla to process that information to run, secure, support, and improve the service. Chessla may use de-identified and aggregated game, product, and usage data to improve analysis, coaching, reliability, and future features.",
  ],
  [
    "FUTURE PUBLIC FEATURES",
    "Chessla will not publish your identifiable profile, games, rating, or activity in a leaderboard or other public feature without a separate visible setting or opt-in. You can change that setting if and when such a feature exists.",
  ],
  [
    "ACCEPTABLE USE",
    "Do not abuse the service, evade limits, interfere with it, or use another person's account or data without permission. We may suspend access for material misuse or to protect the service and players.",
  ],
  [
    "CHANGES",
    "We may update the service or these Terms when reasonably necessary. Material changes will be presented before continued use where required.",
  ],
];

export const TermsAgreementDialog = ({ open, onClose }: { open: boolean; onClose: () => void }) => (
  <DialogShell
    open={open}
    onClose={onClose}
    title="TERMS OF AGREEMENT"
    actions={
      <Button onClick={onClose} variant="contained">
        I understand
      </Button>
    }
  >
    <Typography variant="caption" sx={{ color: "text.secondary" }}>
      Effective {TERMS_VERSION}
    </Typography>
    <Box sx={{ maxHeight: "58vh", overflowY: "auto", pr: 0.5, mt: 1.5 }}>
      {sections.map(([heading, copy]) => (
        <Box key={heading} sx={{ mb: 2 }}>
          <Typography variant="caption" sx={{ color: "primary.main", fontWeight: 800 }}>
            {heading}
          </Typography>
          <Typography variant="body2" sx={{ color: "text.secondary", mt: 0.35 }}>
            {copy}
          </Typography>
        </Box>
      ))}
    </Box>
  </DialogShell>
);
